/**
 * Detect page language from various sources
 * @returns {string} - detected language ('de' or 'en')
 */
export function detectLanguage() {
  // Check for a data-language attribute on html or body
  const dataLang = document.documentElement.getAttribute('data-language') || document.body.getAttribute('data-language');
  if (dataLang) {
    return dataLang;
  }

  // Check URL path for language indicator
  const path = window.location.pathname;
  if (path.includes('/en/')) {
    return 'en';
  }

  return 'de'; // Default fallback
}

// New helper function for consistent label handling
export function getLocalizedLabels(data, language) {
  if (!data) return {};

  // If data has language-specific label objects
  if (language === 'en' && data.labelsEn) {
    return data.labelsEn;
  }

  return data.labels || {};
}
